import { render, staticRenderFns } from "./checkBoxForm.vue?vue&type=template&id=b1d821fe&scoped=true&"
import script from "./checkBoxForm.vue?vue&type=script&lang=js&"
export * from "./checkBoxForm.vue?vue&type=script&lang=js&"
import style0 from "./checkBoxForm.vue?vue&type=style&index=0&id=b1d821fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d821fe",
  null
  
)

export default component.exports